module.exports = __webpack_public_path__ + "static/media/law.91661f11.svg";